import React from 'react'
import './Footer.css'
import { FaFacebook, FaLinkedin, FaMailBulk, FaPhone, FaSearchLocation, FaTwitter } from 'react-icons/fa'

const Footer = () => {
  return (
    <div className='footer'>
      <div className='footer-container'>
        <div className='left'>
          <div className='location'>
            <FaSearchLocation size={20} style={{ color: '#ffffff', marginRight: '2rem' }} />
            <div>
              <p>561</p>
              <h4>Phattanakarn</h4>
            </div>
          </div>
          <div className='phone'>
            <h4><FaPhone size={20} style={{ color: '#ffffff', marginRight: '2rem' }} />091-111-1111</h4>
          </div>
          <div className='email'>
            <h4><FaMailBulk size={20} style={{ color: '#ffffff', marginRight: '2rem' }} />ou_za_za@hotmail.com</h4>
          </div>
        </div>
        <div className='right'>
          <h4>About the company</h4>
          <p>Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>

          <div className='social'>
            <FaFacebook size={30} style={{ color: '#ffffff', marginRight: '1rem' }} />
            <FaTwitter size={30} style={{ color: '#ffffff', marginRight: '1rem' }} />
            <FaLinkedin size={30} style={{ color: '#ffffff', marginRight: '1rem' }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer